import { useCallback, useSyncExternalStore } from "react";

// Whether a CSS media query matches right now, kept in step with the viewport. Read through
// useSyncExternalStore so the first render already agrees with the window instead of drawing
// the wide layout and correcting itself a frame later.
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
